import React from 'react'
import NavPaneTile from '../NavPaneTile/NavPaneTile.js'
import HorizontalSeparator from '../HorizontalSeparator/HorizontalSeparator.js'
import { useSelector } from 'react-redux'

const NavPane = ({ activePage }) => {
  const isLoggedIn = useSelector(state => state.user.isLoggedIn)

  // Toggle this or set your Live Server port during local testing
  const STATIC_SITE_BASE = '/' 
  // On production hosting (IONOS), set: const STATIC_SITE_BASE = ''

  return (
    <div 
      className="w-56 h-full flex-none relative z-20 overflow-y-auto"
      style={{
        background: 'linear-gradient(180deg, #3d3d3d 0%, #282828 25%, #1a1a1a 60%, #121212 100%)',
        borderRight: '1px solid #0a0a0a',
        boxShadow: `
          4px 0px 16px rgba(0, 0, 0, 0.5),
          inset -1px 0px 0px rgba(255, 255, 255, 0.12),
          inset 0px 1px 0px rgba(255, 255, 255, 0.2)
        `
      }}
    >
      <div className="p-3 grid gap-1.5">
        
        {/* MAIN NAVIGATION (REACT ROUTES) */}
        <NavPaneTile 
          name="Home" 
          link="/" 
          icon="fa-sharp fa-solid fa-house" 
          color="text-gray-200" 
          activePage={activePage} 
        />

        {isLoggedIn && (
          <>
            <NavPaneTile 
              name="Recent" 
              link="/recent" 
              icon="fa-sharp fa-solid fa-history" 
              color="text-gray-200" 
              activePage={activePage} 
            />
            <NavPaneTile 
              name="Liked" 
              link="/liked" 
              icon="fa-sharp fa-solid fa-thumbs-up" 
              color="text-gray-200" 
              activePage={activePage} 
            />

            <NavPaneTile 
              name="---" 
              icon="fa-sharp fa-solid fa-upload" 
              color="text-gray-400" 
              activePage={activePage} 
            />
          </>
        )}

        {/* Skeuomorphic Deep Inset Separator */}
        <div className="my-1 border-b border-black/90 shadow-[0_1px_0_rgba(255,255,255,0.12)]" />

        {/* CATEGORIES SECTION (REACT ROUTES) */}
        <div className="px-2 pt-1 pb-0.5 text-[11px] font-extrabold uppercase tracking-widest text-gray-400 drop-shadow-[0_1px_2px_rgba(0,0,0,0.9)]">
          Categories
        </div>

        <NavPaneTile 
          name="Anime" 
          link="/Category?cat=Anime" 
          icon="fa-solid fa-tv" 
          color="text-gray-200" 
          activePage={activePage} 
        />
        <NavPaneTile 
          name="Tech" 
          link="/Category?cat=Tech" 
          icon="fa-solid fa-microchip" 
          color="text-gray-200" 
          activePage={activePage} 
        />
        <NavPaneTile 
          name="Gaming" 
          link="/Category?cat=Gaming" 
          icon="fa-solid fa-gamepad" 
          color="text-gray-200" 
          activePage={activePage} 
        />
        <NavPaneTile 
          name="Vlogs" 
          link="/Category?cat=Video" 
          icon="fa-solid fa-video" 
          color="text-gray-200" 
          activePage={activePage} 
        />
        <NavPaneTile 
          name="Reviews" 
          link="/Category?cat=Reviews" 
          icon="fa-solid fa-star" 
          color="text-gray-200" 
          activePage={activePage} 
        />

        {/* Skeuomorphic Deep Inset Separator */}
        <div className="my-1 border-b border-black/90 shadow-[0_1px_0_rgba(255,255,255,0.12)]" />
        
        {/* EXTERNAL STATIC PAGES */}
        <div className="px-2 pt-1 pb-0.5 text-[11px] font-extrabold uppercase tracking-widest text-gray-400 drop-shadow-[0_1px_2px_rgba(0,0,0,0.9)]">
          Site Pages
        </div>

        <NavPaneTile 
          name="home" 
          link={`${STATIC_SITE_BASE}index.html`} 

          color="text-gray-200" 
        />
        <NavPaneTile 
          name="feed" 
          link={`${STATIC_SITE_BASE}feed.html`} 

          color="text-gray-200" 
        />
        <NavPaneTile 
          name="chat" 
          link={`${STATIC_SITE_BASE}chat.html`} 

          color="text-gray-200" 
        />

      </div>
    </div>
  )
}

export default NavPane
